// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Divider,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider';
import Swal from 'sweetalert2'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [listData, setListData] = useState<any[]>([])
    const navigate = useNavigate();

    useEffect(() => {
        getData()
    }, [])
    const getData = () => {
        showToast("Loading...", "loading");
        let url = apiUrl.apiUrl + '/report/mrp/list'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const convertComponent = [
    {
        key: 'nama_barang',
        renderCell: ({ row }: any) => (
        <div
            style={{
            maxWidth: 300,
            whiteSpace: 'normal',     // allow wrap
            wordBreak: 'break-word', // pecah kata panjang
            lineHeight: '1.4'
            }}
        >
            {row.data.nama_barang}
        </div>
        )
    }
    ]


    
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MATERIAL RESOURCE PLANNING' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                            <Button
                                variant='contained'
                                color='secondary'
                                sx={{mr:3}}
                                startIcon={<Icon icon='mdi:plus' />}
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Konfirmasi',
                                        text: 'Apakah anda ingin membuat Purchase Request dari data MRP ini?',
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonColor: '#9c27b0',
                                        cancelButtonColor: '#ffc107',
                                        confirmButtonText: 'Buat PR'
                                        }).then(result => {
                                        if (result.isConfirmed) {
                                            Swal.fire({
                                            title: 'Now loading',
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            didOpen: () => Swal.showLoading()
                                            })
                                    
                                            const url = `${apiUrl.apiUrl}/report/mrp/create-pr-mrp`
                                    
                                            axios
                                            .post(url, {}, {
                                                headers: {
                                                Authorization: `Bearer ${token}`,
                                                },
                                            })
                                            .then(response => {
                                                if (response.data.success) {
                                                Swal.fire({
                                                    title: 'Berhasil',
                                                    text: response.data.message,
                                                    icon: 'success',
                                                    timer: 1200,
                                                    timerProgressBar: true,
                                                    willClose: () => navigate('/purchasing/purchase-request/detail/' + response.data.data)
                                                })
                                                } else {
                                                Swal.fire({
                                                    title: 'Gagal',
                                                    text: response.data.message,
                                                    icon: 'error'
                                                })
                                                }
                                            })
                                            .catch(error => {
                                                Swal.fire({
                                                title: 'Error',
                                                text: error.message,
                                                icon: 'error'
                                                })
                                            })
                                        }
                                        })
                                    }
                                }
                            >
                                Buat Purchase Request
                            </Button>
                            <Button
                                variant='contained'
                                startIcon={<Icon icon='mdi:magnify' />}
                                onClick={() => getData()}
                            >
                                Refresh Data
                            </Button>
                        </Box>
                            <MsiDatagrid array={listData} customRender={convertComponent} />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}